import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { FileSelectorViewModel, ServerSideDataLoader } from "uicomponents";
import { CustomerAttributeViewModel } from "../customerAttribute/customerAttribute-viewModel";
import { SearchCustomerViewModel } from "../searchCustomer/searchCustomer-viewModel";
import { Customer, CustomerManipulationViewModel, MonopolyDistrict } from "./customerManipulation-viewModel"
import { getAsBoolean } from "src/uicomponents/components/utilities";

export class CustomerManipulationView extends View<CustomerManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-E9BB8143-341B-4F9D-8F3B-5E288896E886"
    }
    loadHtml(): string {
        let element = require('./customerManipulation.html').default;
        let style = require('./customerManipulation.less');
        return element;
    }
    constructor() {
       super();
    }
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set customers(v: ObservableArray<Customer>) { this._customers = v; } public get customers(): ObservableArray<Customer> { return this._customers;} private _customers: ObservableArray<Customer>;
    public set customerSelector(v: SearchCustomerViewModel) { this._customerSelector = v; } public get customerSelector(): SearchCustomerViewModel { return this._customerSelector;} private _customerSelector: SearchCustomerViewModel;
    public set monopolyDistricts(v: ObservableArray<MonopolyDistrict>) { this._monopolyDistricts = v; } public get monopolyDistricts(): ObservableArray<MonopolyDistrict> { return this._monopolyDistricts;} private _monopolyDistricts: ObservableArray<MonopolyDistrict>;
    public set customerAttributes(v: ObservableArray<CustomerAttributeViewModel>) { this._customerAttributes = v; } public get customerAttributes(): ObservableArray<CustomerAttributeViewModel> { return this._customerAttributes;} private _customerAttributes: ObservableArray<CustomerAttributeViewModel>;
    public set fileSelector(v: FileSelectorViewModel) { this._fileSelector = v; } public get fileSelector(): FileSelectorViewModel { return this._fileSelector;} private _fileSelector: FileSelectorViewModel;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;  

    newAttribute() {
        this.dataContext.newAttribute();
    }

    import() {
        this.dataContext.import();
    }
    
    exportAllCustomers() {
        this.dataContext.exportAllCustomers();
    }
    
    editCheckPointMonopolyTime() {
        this.dataContext.editCheckPointMonopolyTime();
    }
}
